<template>
  <nav class="navbar" :class="{ 'is-sticky': isSticky }">
    <div class="nav-container">
      <a href="/" class="logo" @click.prevent="goRoute('/')">
        <img :src="logoSrc" alt="FM WhatsApp Logo">
        <span class="logo-text">FM WhatsApp</span>
      </a>

      <ul class="nav-menu">
        <li>
          <a href="/" :class="{ active: isRouteActive('/') }" @click.prevent="goRoute('/')">Home</a>
        </li>
        <li @mouseenter="showDropdown" @mouseleave="hideDropdown">
          <a href="javascript:void(0)" class="mod-toggle" @click.prevent>
            <span>Mod</span>
            <span class="mod-caret" :class="{ 'is-open': isDropdownOpen }" />
          </a>
          <ul class="dropdown" :class="{ 'show-dropdown': isDropdownOpen }">
            <li><a href="/gbwhatsapp-apk/" @click.prevent="goRoute('/gbwhatsapp-apk/')">GBWhatsApp</a></li>
            <li><a href="/yowhatsapp-apk/" @click.prevent="goRoute('/yowhatsapp-apk/')">YoWhatsApp</a></li>
            <li><a href="/ogwhatsapp-apk/" @click.prevent="goRoute('/ogwhatsapp-apk/')">OGWhatsApp</a></li>
            <li><a href="/jtwhatsapp-apk/" @click.prevent="goRoute('/jtwhatsapp-apk/')">JTWhatsApp</a></li>
            <li><a href="/mbwhatsapp-apk/" @click.prevent="goRoute('/mbwhatsapp-apk/')">MBWhatsApp</a></li>
            <li><a href="/blue-whatsapp-plus-apk/" @click.prevent="goRoute('/blue-whatsapp-plus-apk/')">Blue WhatsApp Plus</a></li>
          </ul>
        </li>
        <li>
          <a
            href="/download/"
            class="nav-download"
            :class="{ active: isRouteActive('/download') || isRouteActive('/download/') }"
            @click.prevent="goRoute('/download/')">
            Download
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'FmNavBar',
  data() {
    return {
      logoSrc: require('@/assets/fm-logo.png'),
      isDropdownOpen: false,
      isSticky: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goRoute(path) {
      if (!this.$router) return
      if (this.$route && this.$route.path === path) return
      this.$router.push(path).catch(() => {})
    },
    isRouteActive(path) {
      if (!this.$route) return false
      return this.$route.path === path
    },
    showDropdown() {
      this.isDropdownOpen = true
    },
    hideDropdown() {
      this.isDropdownOpen = false
    },
    handleScroll() {
      this.isSticky = window.scrollY > 2
    },
  },
}
</script>

<style scoped>
.navbar {
  background: #ffffff;
  padding: 8px 32px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 999;
  transition: box-shadow 0.2s ease;
}
.navbar.is-sticky {
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}
.nav-container {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}
.logo img {
  width: 34px;
  height: 34px;
  object-fit: contain;
}
.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #075e54;
  line-height: 1;
}
.nav-menu {
  display: flex;
  align-items: center;
  gap: 18px;
}
.nav-menu > li {
  padding: 0 30px;
  list-style: none;
  position: relative;
}
.nav-menu a {
  text-decoration: none;
  color: #333;
  font-size: 15px;
  font-weight: 500;
  transition: 0.2s;
  display: block;
  padding: 6px 0;
}
.mod-toggle {
  display: inline-flex !important;
  align-items: center;
  gap: 6px;
}
.mod-caret {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 6px solid currentColor;
  transition: transform 0.2s ease;
  transform-origin: center 35%;
}
.mod-caret.is-open {
  transform: rotate(180deg);
}
.nav-menu a:hover,
.nav-menu a.active {
  color: #25d366;
}
.dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 210px;
  padding: 10px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50%) translateY(6px);
  transition: all 0.2s ease;
  z-index: 9999;
}
.dropdown li {
  list-style: none;
  padding: 0 15px;
}
.dropdown li a {
  padding: 8px 10px;
  border-radius: 4px;
}
.dropdown li a:hover {
  background: #f0f0f0;
}
.nav-menu li:hover .dropdown,
.show-dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}
.nav-download {
  background: #25d366;
  color: #fff !important;
  padding: 9px 22px !important;
  border-radius: 50px;
  font-weight: 700;
}
.nav-download:hover {
  background: #1ea854 !important;
}

@media (max-width: 768px) {
  .navbar {
    padding: 8px 18px;
  }
  .nav-container {
    padding: 0 8px;
  }
  .nav-menu {
    gap: 10px;
  }
  .nav-menu a {
    font-size: 14px;
  }
  .logo-text {
    font-size: 20px;
  }
  .dropdown {
    width: 180px;
  }
  .nav-download {
    padding: 8px 16px !important;
  }
}
</style>
